module.exports = __webpack_public_path__ + "img/IDI.41f01753.png";